/* NR · QUIZ "EL IDEAL" — motor (spec-quiz-el-ideal-v1 §12 · mockup v5 APROBADO Jul 4).
   Tres piezas, cero Empire:
   1) TAKEOVER a pantalla completa (mismo lenguaje que el crawler de filtros): intro + preguntas.
      Cada respuesta = un filtro NATIVO exacto; NO hay motor de recomendación nuevo.
   2) ATERRIZAJE: navega a /collections/{target}?filter... y deja el marcador `nr:ideal` en sessionStorage.
   3) BANDA DE RESULTADOS + RELAJACIÓN (lado Colección, opción A §12e): revela el callout, clona los chips
      activos como "perfil", y si hay pocos resultados suelta el filtro menos importante y re-consulta
      (via __nrApplyUrl de nr-collection.js) hasta llegar al mínimo. Nunca suelta Género/Deporte/Terreno. */
(function () {
  'use strict';
  if (window.__nrIdeal) return; window.__nrIdeal = true;

  var cfgEl = document.querySelector('[data-nr-ideal-config]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  CFG.min = CFG.min || 4;
  CFG.target = String(CFG.target || 'calzado').trim();

  var P = 'filter.p.m.custom.';
  var GENERO_PARAM = P + 'padre_intenciondegenero';
  var FLAG = 'nr:ideal', ANSKEY = 'nr:ideal:answers', TTL = 1800000; // 30 min (mismo criterio que el estado de paginación)

  /* Íconos = el sprite NR (nr-icon-sprite, render único en theme.liquid) — misma fuente que el resto del sitio. */
  function ico(id, size) {
    var s = size || 20;
    return '<svg class="nr-ico" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="#nr-' + id + '"></use></svg>';
  }

  /* ---------- Las 8 preguntas — copies del mockup v5 APROBADO + spec §12 ----------
     block: bloques de la barra de progreso · always: obligatoria (no apagable, sin Omitir)
     v = valor EXACTO del metafield (regla dura §12c) · l = etiqueta amigable aprobada · d = descripción (2ª fila) */
  var QUESTIONS = [
    { id: 'deporte', block: 'deporte', always: true, param: P + 'padre_deporte',
      title: '¿Para qué deporte lo quieres?', hint: 'Elige tu deporte para empezar', type: 'cards',
      options: [
        { v: 'Running', l: 'Running', d: 'Asfalto, trail o pista', run: true },
        { v: 'Triatlon', l: 'Triatlón', d: 'Las de correr del tri' }, /* rama CORTA (Ricardo, parte 9): termina con género+Triatlón — sin run:true ya no pasa a terreno */
        { v: 'Gimnasio', l: 'Entrenar en el gym', d: 'Cross-training, pesas' },
        { v: 'Tenis', l: 'Jugar tenis' },
        { v: 'Voleibol', l: 'Jugar vóley' },
        { v: 'Caminata De Montaña', l: 'Caminata de montaña', d: 'Senderismo, no trail running' },
        { v: 'Multideporte', l: 'Multideporte', d: 'Deportes de salón: tenis de mesa, balonmano' }
      ] },
    { id: 'terreno', block: 'uso', always: true, param: P + 'padre_deporte_subdisciplinarunning',
      title: '¿Dónde vas a correr?', hint: 'Elige dónde corres',
      help: 'Cuéntanos en qué superficie o terreno vas a correr con este zapato.', type: 'cards',
      options: [
        { v: 'Asfalto', l: 'Asfalto', d: 'Calle, parque, pista de atletismo' },
        { v: 'Trail Running', l: 'Trail', d: 'Montaña, tierra, sendero técnico' }
      ] },
    { id: 'distancia', block: 'uso', skippable: true, relax: 5, rlabel: 'distancia', param: P + 'padre_distancia',
      title: '¿Qué distancia te gustaría correr con tu zapato ideal?',
      help: 'Cuéntanos tu distancia favorita con este zapato y elegimos el que mejor funciona para ti — en lo técnico y en el confort.',
      type: 'chips',
      options: [{ v: 'Pista' }, { v: '5km' }, { v: '10km' }, { v: '15km' }, { v: '21km' }, { v: '42km' }, { v: 'Ultra' }] },
    { id: 'nivel', block: 'tu', skippable: true, relax: 2, rlabel: 'nivel', param: P + 'padre_experienciacorredor',
      title: '¿Cuál es tu nivel corriendo?',
      help: 'Sin presión — es tu autopercepción, y nos ayuda a afinar la exigencia del zapato.', type: 'cards',
      options: [
        { v: 'Principiante', l: 'Principiante', d: 'Estás empezando: hasta 10K, una o dos salidas por semana' },
        { v: 'Intermedio', l: 'Intermedio', d: 'Corres con constancia, quizá con un plan; menos de 3 años en esto' },
        { v: 'Avanzado', l: 'Avanzado', d: 'Corres casi a diario y llevas más de 3 años en el running' }
      ] },
    { id: 'peso', block: 'tu', skippable: true, relax: 6, rlabel: 'peso corporal', param: P + 'padre_pesodelcorredor',
      title: '¿Cuál es tu peso corporal?',
      help: 'No juzgamos tu cuerpo: define cuánta espuma y firmeza necesita tu suela. Es el factor de mayor peso en la recomendación.',
      type: 'cards',
      options: [
        { v: 'Menor a 60 Kg' }, { v: '60 a 65 Kg' }, { v: '65 a 70 Kg' }, { v: '70 a 75 Kg' }, { v: '75 a 80 Kg' },
        { v: '80 a 85 Kg' }, { v: '85 a 90 Kg' }, { v: '90 a 95 Kg' }, { v: 'Mayor a 95 Kg' }
      ] },
    { id: 'ritmo', block: 'tu', skippable: true, relax: 4, rlabel: 'ritmo de carrera', param: P + 'padre_ritmocarrera',
      title: '¿A qué ritmo de carrera sueles entrenar?',
      help: 'El ritmo se mide en minutos por kilómetro: si corres 5K en 30 minutos, tu ritmo es 6:00 min/km. Elige el que más se parezca a tus entrenos.',
      type: 'chips',
      options: [
        { v: '2:45 min/Km' }, { v: '3:00 min/Km' }, { v: '3:15 min/Km' }, { v: '3:30 min/Km' }, { v: '3:45 min/Km' },
        { v: '4:00 min/Km' }, { v: '4:15 min/Km' }, { v: '4:30 min/Km' }, { v: '4:45 min/Km' }, { v: '5:00 min/Km' },
        { v: '5:15 min/Km' }, { v: '5:30 min/Km' }, { v: '5:45 min/Km' }, { v: '6:00 min/Km' }, { v: 'Mayor a 6:15 min/Km' }
      ] },
    { id: 'amortiguacion', block: 'pref', skippable: true, relax: 3, rlabel: 'amortiguación', param: P + 'padre_amortiguaci_n',
      title: '¿Qué tanta amortiguación te gusta?',
      help: 'Es la sensación bajo el pie: qué tan blando o firme se siente el zapato al pisar. No hay mejor ni peor — es tu preferencia.',
      type: 'cards',
      options: [ /* "Baja" NO se ofrece (0 productos — decisión Ricardo §12c) */
        { v: 'Media', l: 'Media', d: 'Equilibrada: sientes el piso, respuesta firme' },
        { v: 'Alta', l: 'Alta', d: 'Blanda y protegida: la favorita para entrenar a diario' },
        { v: 'Superior', l: 'Superior', d: 'Máximo colchón: suavidad total para kilómetros largos' }
      ] },
    { id: 'pisada', block: 'pref', skippable: true, relax: 1, rlabel: 'pisada', param: P + 'padre_pisadacorredor',
      title: '¿Cómo es tu pisada?',
      help: 'La pisada no es lo más importante para elegir tu calzado ideal: tu peso corporal y los kilómetros que corres marcan mucho más la diferencia — y eso ya nos lo contaste. De hecho, muchos corredores completan hasta su primera media maratón sin haberse hecho un análisis de pisada. Si la conoces, déjanosla saber; y si no, tranquilo — cuando subas tu volumen o tu ritmo, o sientas alguna molestia, ahí sí vale la pena hacerte el análisis y afinar este detalle.',
      type: 'cards',
      options: [
        { v: 'Neutro', l: 'Neutra', d: 'El pie apoya parejo cuando corres', tip: 'La más común. El pie rueda de forma equilibrada del talón a la punta.' },
        { v: 'Pronador', l: 'Pronación', d: 'El tobillo se desplaza hacia adentro al apoyar', tip: 'Al despegar cargas más sobre el dedo gordo. Se compensa con soporte en el arco.' },
        { v: 'Supinador', l: 'Supinación', d: 'Apoyas más el borde externo del pie', tip: 'Al despegar, más fuerza en los dedos externos. Pide amortiguación neutra y flexible.' }
      ] }
  ];
  var BLOCKS = [
    { id: 'deporte', label: 'Tu deporte' },
    { id: 'uso', label: 'Tu uso' },
    { id: 'tu', label: 'Tú' },
    { id: 'pref', label: 'Preferencia' }
  ];
  /* Orden de relajación (§3/§12e) — vive en cada pregunta (campo relax); nunca se sueltan Género · Deporte · Terreno. */
  var RELAX_ORDER = QUESTIONS.filter(function (q) { return q.relax; })
    .sort(function (a, b) { return a.relax - b.relax; })
    .map(function (q) { return q.id; });

  /* Preguntas activas: obligatorias siempre; omitibles apagables por el editor (schema). */
  var quiz = QUESTIONS.filter(function (q) { return q.always || !CFG.q || CFG.q[q.id] !== false; });
  var Q_BY_ID = {};
  QUESTIONS.forEach(function (q) { Q_BY_ID[q.id] = q; });

  var root = document.querySelector('[data-nr-collection]');

  /* ---------- Marcador nr:ideal (sessionStorage §12e) ---------- */
  function readFlag() {
    try {
      var s = sessionStorage.getItem(FLAG); var f = s ? JSON.parse(s) : null;
      if (f && f.t && (Date.now() - f.t) > TTL) { sessionStorage.removeItem(FLAG); return null; }
      return f;
    } catch (e) { return null; }
  }
  function writeFlag(f) { try { f.t = Date.now(); sessionStorage.setItem(FLAG, JSON.stringify(f)); } catch (e) {} }
  function clearFlag() { try { sessionStorage.removeItem(FLAG); } catch (e) {} }
  function onTarget() {
    var seg = window.location.pathname.replace(/\/+$/, '').split('/').pop();
    return seg.toLowerCase() === CFG.target.toLowerCase();
  }
  function gridCount() {
    var g = root && root.querySelector('[data-nr-grid]');
    return g ? (parseInt(g.getAttribute('data-nr-count'), 10) || 0) : 0;
  }

  /* ---------- TAKEOVER ---------- */
  var ov = null;
  var state = { genero: 'Mujer', i: -1, answers: {} }; // i = -1 → intro

  function build() {
    ov = document.createElement('div');
    ov.className = 'nri-tk';
    ov.innerHTML =
      '<div class="nri-tk__panel" role="dialog" aria-modal="true" aria-label="Quiz El Ideal — encuentra tu calzado ideal">' +
        '<div class="nri-tk__head">' +
          '<button type="button" class="nri-tk__nav" data-nri-back aria-label="Atrás">' + ico('arrow-left') + '</button>' +
          '<span class="nri-tk__brand">' + ico('square-check-big') + '<span>Quiz El Ideal</span></span>' +
          '<button type="button" class="nri-tk__nav" data-nri-x aria-label="Salir">' + ico('x') + '</button>' +
        '</div>' +
        '<div class="nri-tk__prog" data-nri-prog hidden></div>' +
        '<div class="nri-tk__body"><div class="nri-tk__col" data-nri-col></div></div>' +
        '<div class="nri-tk__foot" data-nri-foot></div>' +
      '</div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', onOverlayClick);
    /* Focus trap (veredicto K3, patrón H7/lightbox): Tab atrapado dentro del takeover.
       OJO: a[href] estricto — un [href] a secas matchea los <use href="#nr-…"> de los SVG
       (no enfocables) y el trap nunca envuelve (bug cazado en vivo, sesión F). */
    ov.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var all = ov.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var f = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].disabled) continue;
        var cs = getComputedStyle(all[i]);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        f.push(all[i]);
      }
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  var lastTrigger = null; /* disparador para el retorno de foco (K3) */
  function open(genero) {
    if (!ov) build();
    lastTrigger = document.activeElement;
    /* SIN preselección (Ricardo, sesión F parte 8 — supersede el §8 «recordar respuestas»):
       cada corrida arranca LIMPIA para que elegir sea siempre un acto explícito que habilita
       el botón. Solo se recuerda el GÉNERO (para «Rehacer el quiz»). */
    state.answers = {};
    try {
      var s = JSON.parse(localStorage.getItem(ANSKEY) || 'null');
      if (s && s.genero) state.genero = s.genero;
    } catch (e) {}
    if (genero) state.genero = genero;
    state.i = -1;
    render();
    ov.classList.add('is-open');
    document.body.classList.add('nri-open');
    var x = ov.querySelector('[data-nri-x]'); if (x) x.focus(); /* foco a la ✕ al abrir (K3) */
  }
  function close() {
    if (!ov || !ov.classList.contains('is-open')) return;
    ov.classList.remove('is-open');
    document.body.classList.remove('nri-open');
    if (lastTrigger && lastTrigger.focus && document.contains(lastTrigger)) lastTrigger.focus(); /* retorno (K3) */
    lastTrigger = null;
  }

  function introHtml() {
    return '<h2 class="nri-tk__hi" tabindex="-1">Vamos a encontrar tu calzado ideal.</h2>' +
      '<div class="nri-tk__gender">Buscando para ' + (state.genero === 'Hombre' ? 'hombre' : 'mujer') +
        ' <button type="button" data-nri-genero-swap>cambiar</button></div>' +
      '<p class="nri-tk__p">Te haremos unas preguntas cortas sobre tus <b>hábitos de running</b> — el terreno donde corres, tu distancia, tu ritmo — y con eso te mostramos el calzado que mejor va a funcionar para ti. Ese es nuestro trabajo: el zapato ideal según el uso que le vas a dar.</p>' +
      '<p class="nri-tk__p">Y recuerda: la <b>rotación de calzado</b> importa. Si corres en terrenos distintos o entrenas distancias diferentes, es bueno rotar — repite el quiz y encuentra el ideal para cada uno.</p>';
  }

  function progHtml(q) {
    var curIdx = 0, bi;
    for (bi = 0; bi < BLOCKS.length; bi++) { if (BLOCKS[bi].id === q.block) { curIdx = bi; break; } }
    /* Semántica del progreso para lectores de pantalla (veredicto K15) */
    var html = '<span class="nri-sr">Pregunta ' + (quiz.indexOf(q) + 1) + ' de ' + quiz.length + '</span>';
    BLOCKS.forEach(function (b, i) {
      var qs = quiz.filter(function (x) { return x.block === b.id; });
      if (!qs.length) return;
      var fill = 0;
      if (i < curIdx) fill = 100;
      else if (i === curIdx) fill = Math.round((qs.indexOf(q) + 1) / qs.length * 100);
      html += '<div class="nri-tk__pb"><div class="nri-tk__pbar"><i style="width:' + fill + '%"></i></div>' +
        '<div class="nri-tk__plabel' + (i === curIdx ? ' is-on' : '') + '">' + b.label + '</div></div>';
    });
    return html;
  }

  function qHtml(q) {
    var h = '<h2 class="nri-tk__q" tabindex="-1">' + q.title + '</h2>';
    if (q.help) h += '<div class="nri-tk__why">' + ico('info', 16) + '<span>' + q.help + '</span></div>';
    var sel = state.answers[q.id];
    if (q.type === 'chips') {
      h += '<div class="nri-tk__chips">';
      q.options.forEach(function (o) {
        h += '<button type="button" class="nri-chipf' + (sel === o.v ? ' is-sel' : '') + '" data-nri-opt="' + o.v.replace(/"/g, '&quot;') + '" aria-pressed="' + (sel === o.v) + '">' + (o.l || o.v) + '</button>';
      });
      h += '</div>';
    } else {
      h += '<div class="nri-tk__opts">';
      q.options.forEach(function (o, oi) {
        /* «?» del tooltip = <button> HERMANO superpuesto (veredicto K4: nunca interactivo anidado);
           la burbuja es hermana con id → aria-describedby. Enter/Space nativos del button. */
        var tipId = 'nri-tip-' + q.id + '-' + oi;
        var optBtn = '<button type="button" class="nri-opt' + (sel === o.v ? ' is-sel' : '') + (o.tip ? ' nri-opt--tip' : '') + '" data-nri-opt="' + o.v.replace(/"/g, '&quot;') + '" aria-pressed="' + (sel === o.v) + '">' +
          '<span class="nri-opt__head"><span class="nri-opt__t">' + (o.l || o.v) + '</span></span>' +
          (o.d ? '<span class="nri-opt__d">' + o.d + '</span>' : '') +
          '</button>';
        if (o.tip) {
          h += '<div class="nri-optwrap">' + optBtn +
            '<button type="button" class="nri-q" data-nri-tip aria-label="Más información sobre ' + (o.l || o.v) + '" aria-describedby="' + tipId + '">?</button>' +
            '<span class="nri-q__b" id="' + tipId + '" role="tooltip">' + o.tip + '</span></div>';
        } else {
          h += optBtn;
        }
      });
      h += '</div>';
    }
    return h;
  }

  /* ¿La selección actual TERMINA el quiz? (rama corta: Trail en terreno · deporte no-running) */
  function selTermina(q, sel) {
    if (!sel) return false;
    if (q.id === 'terreno' && sel === 'Trail Running') return true;
    if (q.id === 'deporte') {
      var run = false;
      q.options.forEach(function (o) { if (o.v === sel && o.run) run = true; });
      return !run;
    }
    return false;
  }

  /* Pie v2 (Ricardo, sesión F parte 8 — supersede el avance automático del mockup v5): tap = solo
     SELECCIONAR; el avance vive en un botón primario dinámico. Obligatoria sin selección = botón
     DESHABILITADO con el hint · con selección = «Siguiente pregunta →» · omitible sin selección =
     «Saltar pregunta →» · última pregunta o rama corta = «Ver mis resultados →». */
  function footHtml(q) {
    if (!q) return '<button type="button" class="nri-btn nri-tk__go" data-nri-go>Empecemos ' + ico('arrow-right', 15) + '</button>';
    var html = '<button type="button" class="nri-tk__lnk" data-nri-back>' + ico('arrow-left', 15) + ' Atrás</button>';
    var sel = state.answers[q.id];
    var last = quiz.indexOf(q) === quiz.length - 1;
    if (!sel && !q.skippable) {
      html += '<button type="button" class="nri-btn nri-tk__go" disabled>' + (q.hint || 'Elige una opción') + '</button>';
    } else {
      var label;
      if (last || selTermina(q, sel)) label = 'Ver mis resultados ';
      else if (!sel) label = 'Saltar pregunta ';
      else label = 'Siguiente pregunta ';
      html += '<button type="button" class="nri-btn nri-tk__go" data-nri-go>' + label + ico('arrow-right', 15) + '</button>';
    }
    return html;
  }

  function render() {
    var q = state.i >= 0 ? quiz[state.i] : null;
    var back = ov.querySelector('.nri-tk__head [data-nri-back]');
    if (back) back.style.visibility = q ? 'visible' : 'hidden';
    var prog = ov.querySelector('[data-nri-prog]');
    prog.hidden = !q;
    prog.innerHTML = q ? progHtml(q) : '';
    ov.querySelector('[data-nri-col]').innerHTML = q ? qHtml(q) : introHtml();
    ov.querySelector('[data-nri-foot]').innerHTML = footHtml(q);
    ov.querySelector('.nri-tk__body').scrollTop = 0;
    /* El nodo enfocado se destruye con el re-render → re-anclar el foco DENTRO del takeover (K3).
       Ancla = el TÍTULO de la pregunta (tabindex=-1): neutro (un Enter repetido no hace nada) y el
       lector de pantalla anuncia la pregunta nueva. NUNCA la ✕ — Enter tras responder sacaría del quiz. */
    if (ov.classList.contains('is-open') && !ov.contains(document.activeElement)) {
      var anchor = ov.querySelector('.nri-tk__q, .nri-tk__hi') || ov.querySelector('[data-nri-x]');
      if (anchor) anchor.focus();
    }
  }

  function next() {
    state.i++;
    if (state.i >= quiz.length) { finish(); return; }
    render();
  }
  function prev() {
    state.i = state.i <= 0 ? -1 : state.i - 1;
    render();
  }

  /* Aterrizaje: arma la URL de filtros nativos + deja el marcador. Aplica LO RESPONDIDO (las ramas
     cortas —Trail / deporte no-running— llegan aquí con solo sus respuestas → mismo resultado). */
  function finish() {
    try { localStorage.setItem(ANSKEY, JSON.stringify({ genero: state.genero })); } catch (e) {}
    var sp = new URLSearchParams();
    sp.append(GENERO_PARAM, state.genero);
    quiz.forEach(function (q) { var v = state.answers[q.id]; if (v) sp.append(q.param, v); });
    writeFlag({ relaxed: [], relaxDone: false });
    close();
    var url = '/collections/' + CFG.target + '?' + sp.toString();
    var apply = root && root.__nrApplyUrl;
    /* AJAX en sitio si ya estamos en la colección destino; si el motor está ocupado (devuelve false),
       navegación dura — el resultado del quiz NUNCA se pierde en silencio. */
    if (!(onTarget() && apply && apply(url) !== false)) { window.location.href = url; return; }
    /* Empujar al TOP (Ricardo, parte 9): la entrada vive al FONDO de la página — sin esto el cliente
       queda mirando el pie y no ve el callout de resultados. El ancla post-swap de applyUrl no
       re-scrollea (el grid ya queda con top > 0). */
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  /* Avanzar desde el botón primario: aplica el estado de la pregunta actual y decide la ruta. */
  function goNext() {
    var q = state.i >= 0 ? quiz[state.i] : null;
    if (!q) { next(); return; } /* intro → primera pregunta */
    var sel = state.answers[q.id];
    if (!sel) delete state.answers[q.id]; /* saltar = ese filtro NO se aplica (§12g) */
    if (selTermina(q, sel)) { finish(); return; } /* rama corta: Trail · deporte no-running */
    next(); /* next() llama finish() si era la última */
  }

  function onOverlayClick(e) {
    if (e.target.closest('[data-nri-x]')) { close(); return; }
    if (e.target.closest('[data-nri-back]')) { prev(); return; }
    if (e.target.closest('[data-nri-go]')) { goNext(); return; }
    if (e.target.closest('[data-nri-genero-swap]')) {
      state.genero = state.genero === 'Mujer' ? 'Hombre' : 'Mujer';
      render(); return;
    }
    var tip = e.target.closest('[data-nri-tip]');
    if (tip) { tip.classList.toggle('is-open'); return; } /* tap móvil; hover lo cubre el CSS */
    var opt = e.target.closest('[data-nri-opt]');
    if (opt) {
      var q = quiz[state.i]; if (!q) return;
      /* Tap = solo SELECCIONAR (el avance vive en el botón): marca in situ sin re-render
         (no se pierde el scroll de listas largas ni el foco) y refresca el pie. */
      state.answers[q.id] = opt.getAttribute('data-nri-opt');
      var col = ov.querySelector('[data-nri-col]');
      col.querySelectorAll('[data-nri-opt]').forEach(function (b) {
        var on = b === opt;
        b.classList.toggle('is-sel', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      ov.querySelector('[data-nri-foot]').innerHTML = footHtml(q);
    }
  }

  /* ---------- BANDA DE RESULTADOS + RELAJACIÓN (solo en la colección destino) ---------- */
  function paintRelax(f, band) {
    var box = band.querySelector('[data-nr-ideal-relax]');
    if (!box) return;
    if (f.relaxed && f.relaxed.length) {
      var labels = f.relaxed.map(function (k) { return (Q_BY_ID[k] && Q_BY_ID[k].rlabel) || k; });
      var t = box.querySelector('[data-nr-ideal-relax-text]');
      if (t) t.textContent = 'Ampliamos tus resultados para que tengas más opciones de acuerdo a tu ' + labels.join(' y tu ') + '.';
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  }

  /* Si tras filtrar hay menos de CFG.min resultados: suelta el filtro menos importante y re-consulta.
     Corre de a UN paso; el evento nr:collection:updated re-entra hasta asentar (o agotar candidatos). */
  function maybeRelax(f) {
    if (f.relaxDone) return;
    if (gridCount() >= CFG.min) { f.relaxDone = true; writeFlag(f); return; }
    var sp = new URLSearchParams(window.location.search);
    sp.delete('section_id'); sp.delete('page');
    var drop = null, i;
    for (i = 0; i < RELAX_ORDER.length; i++) {
      if (sp.has(Q_BY_ID[RELAX_ORDER[i]].param)) { drop = RELAX_ORDER[i]; break; }
    }
    if (!drop) { f.relaxDone = true; writeFlag(f); return; }
    sp.delete(Q_BY_ID[drop].param);
    var qs = sp.toString(), url = window.location.pathname + (qs ? '?' + qs : '');
    var apply = root && root.__nrApplyUrl;
    if (!apply) {
      (f.relaxed = f.relaxed || []).push(drop);
      writeFlag(f);
      window.location.replace(url);
      return;
    }
    /* El estado se compromete SOLO si el swap arrancó; con el motor ocupado (false) se
       reintenta en el próximo nr:collection:updated/appended — nada queda a medias. */
    if (apply(url, false) === false) return;
    (f.relaxed = f.relaxed || []).push(drop);
    writeFlag(f);
    history.replaceState(null, '', url);    /* la URL se corrige en sitio (sin ensuciar el back) */
  }

  /* Sincroniza la banda con el estado: se llama al cargar y tras cada swap AJAX (los nodos son nuevos). */
  function syncBand() {
    if (!root) return;
    var band = root.querySelector('[data-nr-ideal-band]');
    var f = readFlag();
    if (f && !onTarget()) clearFlag(); /* pisó OTRA colección → el contexto del quiz terminó */
    if (!f || !onTarget()) {
      if (band) band.hidden = true;
      root.classList.remove('nrc--ideal');
      return;
    }
    var chips = root.querySelectorAll('.nrc__bar .nrc__active-chip');
    if (!chips.length) {
      /* Distinguir "el cliente limpió todo" (URL sin filtros → el modo se apaga) de "0 resultados"
         (R-15: Shopify no devuelve active_values → no hay chips AUNQUE la URL traiga filtros).
         En el 2º caso NO se mata la bandera: maybeRelax lee la URL y rescata el resultado
         (regla del quiz: NUNCA cero resultados). nr-collection.js además reconstruye los chips. */
      var spf = new URLSearchParams(window.location.search), hasF = false;
      spf.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasF = true; });
      if (!hasF) { /* limpió de verdad → apagar */
        clearFlag();
        if (band) band.hidden = true;
        root.classList.remove('nrc--ideal');
        return;
      }
    }
    root.classList.add('nrc--ideal');
    if (!band) return;
    band.hidden = false;
    var prof = band.querySelector('[data-nr-ideal-profile]');
    if (prof) {
      prof.innerHTML = '';
      /* Chips del perfil = CLONES de los filtros activos (url_to_remove nativo); el click lo maneja
         la delegación de nr-collection.js (siguen dentro de root y matchean FILTER_SEL). */
      Array.prototype.forEach.call(chips, function (c) { prof.appendChild(c.cloneNode(true)); });
      /* «Limpiar todo» SIEMPRE en línea propia BAJO los chips (Ricardo, parte 9b): fila wrapper
         de ancho completo → el link queda a la izquierda con su aire, sin inflar filas de chips. */
      var clearAll = root.querySelector('.nrc__bar .nrc__active-clear');
      if (clearAll) {
        var row = document.createElement('div');
        row.className = 'nri-band__clearrow';
        row.appendChild(clearAll.cloneNode(true));
        prof.appendChild(row);
      }
    }
    var cnt = band.querySelector('[data-nr-ideal-count]');
    if (cnt) { var gn = gridCount(); cnt.textContent = gn + (gn === 1 ? ' producto' : ' productos'); }
    paintRelax(f, band);
    maybeRelax(f);
  }

  /* ---------- Wiring ---------- */
  document.addEventListener('click', function (e) {
    var start = e.target.closest('[data-nr-ideal-start]');
    if (start) { open(start.getAttribute('data-nr-ideal-start')); return; }
    if (e.target.closest('[data-nr-ideal-redo]')) { clearFlag(); open(null); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (root) {
    /* setTimeout(0): el evento se dispara ANTES del finally que libera el busy de applyUrl →
       diferir garantiza que la relajación pueda encadenar su siguiente paso. */
    root.addEventListener('nr:collection:updated', function () { setTimeout(syncBand, 0); });
    root.addEventListener('nr:collection:appended', function () { setTimeout(syncBand, 0); });
  }
  syncBand(); /* script defer → DOM listo */
})();
